import Vue from 'vue'
// Load apexcharts only when a page renders <apexchart>, keeps it out of the initial bundle
Vue.component('apexchart', () => import('vue-apexcharts'))
